import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=1a346c81"
import script from "./AddToCart.vue?vue&type=script&lang=ts"
export * from "./AddToCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports